<template>
  <modal :visible="visible" @on-close="onClose()">
    <template v-slot:body>
      <div style="background-color:--main-bg-color;" class="nav-pills nav-fill">
        <div class="head-info">
          <th>
            <h6 class="userName">{{ order.docDueDate }}</h6>
          </th>
        </div>
      </div>
      <div>
        {{ order.base64 }}
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn" @click="onClose()">
        {{ $t("buttons.close") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { currencyMixin } from "../mixins";
import Modal from "./Modal";
export default {
  name: "CommentOrderModal",
  components: {
    Modal,
  },
  mixins: [currencyMixin],
  props: {
    order: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visible: Boolean,
  },
  methods: {
    onClose() {
      this.$emit("on-close");
    },
  },
};
</script>
